<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.orderNo" style="width: 120px;" size="mini" placeholder="订单号"
                        clearable></el-input>
                    <el-input v-model="formDatas.ausPhone" style="width: 120px;" size="mini" placeholder="手机号"
                        clearable></el-input>
                    <el-select size="mini" v-model="formDatas.operStatus" clearable @change="partserch"
                        placeholder="请选择订单状态" style="width: 130px">
                        <el-option label="待发货" :value="22"></el-option>
                        <el-option label="已发货" :value="23"></el-option>
                        <el-option label="确认中" :value="24"></el-option>
                        <el-option label="售后中" :value="31"></el-option>
                        <el-option label="失败" :value="51"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.trackState" clearable @change="partserch"
                        placeholder="请选择物流状态" style="width: 130px">
                        <el-option label="未发货" :value="0"></el-option>
                        <el-option label="已发货" :value="1"></el-option>
                        <el-option label="拒收" :value="2"></el-option>
                        <el-option label="投妥" :value="3"></el-option>
                        <el-option label="部分发货" :value="4"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.yoHandlerStatus" clearable @change="partserch"
                        placeholder="请选择处理状态" style="width: 130px">
                        <el-option label="待处理" :value="1"></el-option>
                        <el-option label="已处理" :value="2"></el-option>
                        <el-option label="处理失败" :value="3"></el-option>
                    </el-select>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <!-- <el-button type="primary" size="mini" style="margin-right: 10px;"
                        @click="bulkImport = true">批量导入</el-button> -->
                    <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button>
                    <el-button type="danger" size="mini" style="margin-left: 10px" @click="BulkDelete">批量撤销</el-button> -->
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <!-- <el-button type="success" size="mini" style="margin-right: 20px" @click="BoxOpen">新增银行</el-button> -->

                    <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption" row-key-field-name="yoId"
                        :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑银行' : '新增银行'" :before-close="handleClose"
                :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="银行名称" prop="asboBankName">
                                <el-input v-model="form.asboBankName" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
            <!-- 订单详情   -->
            <el-dialog title="订单详情" :visible.sync="diaDetail" width="80%" top="8vh">
                <el-card v-if="tableDataDetail && tableDataDetail.productList">
                    <div slot="header" class="clearfix">
                        <span>订单商品明细</span>
                        <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
                    </div>
                    <el-table :data="tableDataDetail.productList" border style="width: 100%">
                        <el-table-column prop="orderSubno" label="订单子单号" width="300">
                        </el-table-column>
                        <el-table-column prop="itemCode" label="商品编码" width="180">
                        </el-table-column>
                        <el-table-column prop="itemName" label="商品名称" width="180">
                        </el-table-column>
                        <el-table-column prop="photo" label="商品图片" width="100">
                            <template slot-scope="scope">
                                <img v-if="scope.row.photo" :src="scope.row.photo" alt="商品图片"
                                    style="width: 100%; max-width: 100px;" />
                            </template>
                        </el-table-column>
                        <el-table-column prop="saleNum" label="商品数量" width="120">
                        </el-table-column>
                        <el-table-column prop="salePrice" label="销售价(分)" width="120">
                        </el-table-column>
                        <el-table-column prop="amount" label="销售金额(分)" width="120">
                        </el-table-column>
                        <el-table-column prop="supplyPrice" label="供应价(分)" width="120">
                        </el-table-column>
                        <el-table-column prop="cidName1" label="一级分类名称" width="150">
                        </el-table-column>
                        <el-table-column prop="cidName2" label="二级分类名称" width="150">
                        </el-table-column>
                        <el-table-column prop="cidName3" label="三级分类名称" width="150">
                        </el-table-column>
                        <el-table-column prop="createtime" label="创建时间" width="180">
                        </el-table-column>
                    </el-table>

                </el-card>
                <el-card v-if="tableDataDetail && tableDataDetail.orderLogisticsList">
                    <div slot="header" class="clearfix">
                        <span>订单物流明细</span>
                        <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
                    </div>
                    <el-collapse v-model="activeNames" @change="handleChange">
                        <template v-for="(logistics, index) in tableDataDetail.orderLogisticsList">
                            <el-collapse-item :title="'快递公司:' + logistics.expressName" :name="index">
                                <el-descriptions :column="3" border :labelStyle="{
                                    color: '#409EFF',
                                    textAlign: 'center',
                                    width: '14%',
                                    fontSize: '12px',
                                }" :contentStyle="{
                                    textAlign: 'center',
                                    width: '18%',
                                    fontSize: '12px',
                                }">
                                    <el-descriptions-item label="配送方式:">
                                        {{ logistics.deliveryType === 0 ? '自配送' : '快递' }}
                                    </el-descriptions-item>
                                    <el-descriptions-item label="快递公司">
                                        {{ logistics.express }}
                                    </el-descriptions-item>
                                    <el-descriptions-item label="快递公司名称">
                                        {{ logistics.expressName }}
                                    </el-descriptions-item>
                                    <el-descriptions-item label="订单号">
                                        {{ logistics.orderNo }}
                                    </el-descriptions-item>
                                    <el-descriptions-item label="快递单号">
                                        {{ logistics.expressNo }}
                                    </el-descriptions-item>
                                    <el-descriptions-item label="手机号">
                                        {{ logistics.deliveryMoblie }}
                                    </el-descriptions-item>
                                    <el-descriptions-item label="配送时间">
                                        {{ logistics.deliveryTime }}
                                    </el-descriptions-item>
                                    <el-descriptions-item label="创建时间">
                                        {{ logistics.createtime }}
                                    </el-descriptions-item>
                                    <el-descriptions-item label="更新时间">
                                        {{ logistics.updatetime }}
                                    </el-descriptions-item>
                                </el-descriptions>
                                <el-card v-if="logistics.orderProductList && logistics.orderProductList.length > 0">
                                    <div slot="header" class="clearfix">
                                        <span>订单物流信息商品</span>
                                        <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
                                    </div>
                                    <el-table :data="logistics.orderProductList" border style="width: 100%">
                                        <el-table-column prop="ordersubno" label="订单子单号" width="300">
                                        </el-table-column>
                                        <el-table-column prop="itemcode" label="商品编码" width="180">
                                        </el-table-column>
                                        <el-table-column prop="itemname" label="商品名称" width="180">
                                        </el-table-column>
                                        <el-table-column prop="createtime" label="创建时间" width="180">
                                        </el-table-column>
                                    </el-table>
                                </el-card>
                            </el-collapse-item>
                        </template>
                    </el-collapse>
                </el-card>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import { getYbtOrderDetails, deleteAjefShopBankOptinons, getYbtOrderList, addAjefShopBankOptinons, updateAjefShopBankOptinons } from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {

            theRow: {},
            form2: {},
            diaAddReturn: false,
            diaDetail: false,
            tableDataDetail: [],
            dialogStatusValue: '',
            dialogStatus: false,
            key: 'yoId',
            dialog: false,
            edit: false,
            form: {
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: false,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            activeNames: [],
            columns: [
                // {
                //     field: "",
                //     key: "checkbox",
                //     // type=checkbox
                //     type: "checkbox",
                //     fixed: 'left',
                //     title: "",
                //     width: 50,
                //     align: "center",
                // },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "orderNo",
                    key: "orderNo",
                    title: "订单号",
                    align: "center",
                    fixed: 'left',
                    edit: false,
                    width: 200,
                },
                {
                    field: "orgId",
                    key: "orgId",
                    title: "机构id",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "orgName",
                    key: "orgName",
                    title: "机构名称",
                    align: "center",
                    edit: false,
                    width: 220,
                },

                {
                    field: "siteId",
                    key: "siteId",
                    title: "商城id",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "siteName",
                    key: "siteName",
                    title: "商城名称",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "orderAmount",
                    key: "orderAmount",
                    title: "订单总金额(分)",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "payAmount",
                    key: "payAmount",
                    title: "用户实际支付金额(分)",
                    align: "center",
                    edit: false,
                    width: 160,
                },
                {
                    field: "cashAmount",
                    key: "cashAmount",
                    title: "用户支付现金(分)",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "payPoints",
                    key: "payPoints",
                    title: "用户支付积分",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "freight",
                    key: "freight",
                    title: "用户支付运费(分)",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "paySupplyAmount",
                    key: "paySupplyAmount",
                    title: "机构支付金额(分)",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "supplyFreight",
                    key: "supplyFreight",
                    title: "机构支付运费(分)",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "supplyServiceFee",
                    key: "supplyServiceFee",
                    title: "服务费(分)",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "benefitAmount",
                    key: "benefitAmount",
                    title: "优惠金额(分)",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "vipDiscountAmount",
                    key: "vipDiscountAmount",
                    title: "会员优惠金额(分)",
                    align: "center",
                    edit: false,
                    width: 160,
                },
                {
                    field: "userName",
                    key: "userName",
                    title: "下单人姓名",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "moblie",
                    key: "moblie",
                    title: "下单人手机号",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "userAccount",
                    key: "userAccount",
                    title: "下单人账号",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "confirmDate",
                    key: "confirmDate",
                    title: "下单时间",
                    align: "center",
                    edit: false,
                    width: 180,
                },
                {
                    field: "remark",
                    key: "remark",
                    title: "订单下单备注",
                    align: "center",
                    edit: false,
                    width: 200,
                },
                {
                    field: "supplyId",
                    key: "supplyId",
                    title: "供应商id",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "supplyName",
                    key: "supplyName",
                    title: "供应商名称",
                    align: "center",
                    edit: false,
                    width: 180,
                },
                {
                    field: "receiver",
                    key: "receiver",
                    title: "收货人",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "receiverPhone",
                    key: "receiverPhone",
                    title: "收货人号码",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "address",
                    key: "address",
                    title: "收货人地址",
                    align: "center",
                    edit: false,
                    width: 230,
                },

                {
                    field: "source",
                    key: "source",
                    title: "渠道",
                    align: "center",
                    width: 180,

                },
                {
                    field: "unionid",
                    key: "unionid",
                    title: "unionid",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "openId",
                    key: "openId",
                    title: "公众号或小程序openId",
                    align: "center",
                    edit: false,
                    width: 160,
                },
                
                {
                    field: "yoHandlerDes",
                    key: "yoHandlerDes",
                    title: "处理描述",
                    align: "center",
                    width: 120,
                },
                {
                    field: "trackState",
                    key: "trackState",
                    title: "物流状态",
                    align: "center",
                    // fixed: "right",
                    width: 90,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.trackState == 0 ? <el-tag size="mini" type="warning">未发货</el-tag> :
                                        row.trackState == 1 ? <el-tag size="mini" type="info">已发货</el-tag> :
                                            row.trackState == 2 ? <el-tag size="mini" type="danger">拒收</el-tag> :
                                                row.trackState == 3 ? <el-tag size="mini" type="success">妥投</el-tag> :
                                                    row.trackState == 4 ? <el-tag size="mini" type="primary">部分发货</el-tag> :
                                                        <el-tag size="mini" type="default">未知</el-tag>
                                }
                            </span>
                        );
                    },
                },

                {
                    field: "yoHandlerStatus",
                    key: "yoHandlerStatus",
                    title: "处理状态",
                    align: "center",
                    fixed: "right",
                    width: 90,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.yoHandlerStatus == 1 ? <el-tag size="mini" type="info">待处理</el-tag> :
                                        row.yoHandlerStatus == 2 ? <el-tag size="mini" type="success">已处理</el-tag> :
                                            <el-tag size="mini" type="danger">处理失败</el-tag>
                                }
                            </span>
                        );
                    },
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center",fixed: "right", },
                {
                    field: "operStatus",
                    key: "operStatus",
                    title: "订单状态",
                    align: "center",
                    width: 120,
                    fixed: "right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.operStatus == 22 ? <el-tag size="mini" type="warning">待发货</el-tag> :
                                        row.operStatus == 23 ? <el-tag size="mini" type="success">已完成</el-tag> :
                                            row.operStatus == 24 ? <el-tag size="mini" type="info">确认中</el-tag> :
                                                row.operStatus == 31 ? <el-tag size="mini" type="danger">售后中</el-tag> :
                                                    row.operStatus == 51 ? <el-tag size="mini" type="danger">失败</el-tag> :
                                                        <el-tag size="mini" type="default">未知</el-tag>
                                }
                            </span>
                        );
                    },
                },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 100,
                    align: "center",
                    fixed: "right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: green"
                                    on-click={() => this.handleDetail(row)}
                                >
                                    订单详情
                                </el-button>
                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                dmDelete: 1,
                currentPage: 1,
                pageSize: 10,
            },
            bulkImport: false,
            bulkData: [],
            bulkDataCopy: [],
            sitId: '',
            importData: {},

        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
    },
    mounted() { },
    methods: {
        handleChange(val) {
            console.log(val);
        },
        handleDetail(row) {
            getYbtOrderDetails({ yoId: row.yoId }).then(res => {
                this.activeNames = [];
                this.tableDataDetail = res.data;
                this.diaDetail = true;
            })
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        Out() {
            var s = qs.stringify(this.formDatas);
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL + '/ajef-certificate-record/exportAjefCertificateRecord',
                data: s,
                // withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'user': window.localStorage.getItem('Qy_token')
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close()
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '银行兑换.xlsx');
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });

                }
            })
        },
        bulkImportClick() {
            if (this.sitId == '') {
                this.$message({
                    showClose: true,
                    message: "请导入资料",
                    type: 'danger'
                });
            } else {
                uploadImportAjAssetsKey({
                    sitId: this.sitId
                }).then(res => {
                    this.getList()
                    this.bulkImport = false;
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.sitId = '';
                    this.$refs['bulk'].clearFiles()
                    this.$message({
                        type: 'success',
                        message: '导入成功!'
                    });
                })
            }

        },
        async updatabulk(file, fileList) {
            console.log(file, fileList);
            let Data = new FormData();
            Data.append('file', file.raw)
            this.openLoading()
            uploadAjAssetsFireEquipment(Data).then(res => {
                console.log("上传成功")
                this.loadings.close()
                this.bulkData = res.data.data.resultList;
                this.bulkDataCopy = res.data.data.resultList;
                this.importData = res.data.data.importData;
                this.sitId = res.data.data.sysImportTem.sitId;

            })
        },
        bulkImportClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.$nextTick(() => {
                        this.getList()
                    })
                    this.$refs.bulk.clearFiles();
                })
                .catch(_ => { });
        },
        handleStatus(row) {
            this.theRow = row;
            this.dialogStatusValue = row.aakStatus;
            this.dialogStatus = true;
        },
        sureStatus() {
            updateAjAssetsFireEquipmentStatus({ yoId: this.theRow.yoId, aakStatus: this.dialogStatusValue }).then(res => {
                if (res.data) {
                    this.$message({
                        type: "success",
                        message: "修改成功!",
                    });
                    this.getList();
                    this.dialogStatusValue = ''
                }
            })
            this.dialogStatus = false;
        },
        closeStatus() {
            this.dialogStatus = false;
            this.dialogStatusValue = ''
        },
        // 批量删除
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        cancelAjefCertificateRecordMulti({ yoIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            this.$message({
                                type: "success",
                                message: "成功!",
                            });
                            this.checkboxOption.selectedRowKeys = [];
                            this.selectedRowKeysCollection = [];
                            this.partserch()
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deleteAjefShopBankOptinons({ yoId: row.yoId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const newForm = JSON.parse(JSON.stringify(this.form))
                        if (newForm.acrAmount == 0) {
                            newForm.acrAmount = newForm.acrAmount2
                        }
                        addAjefShopBankOptinons(newForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjefShopBankOptinons(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },

        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.yoId = row.yoId
                    console.log(jsonObj);
                    updateAjefShopBankOptinons(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getYbtOrderList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getYbtOrderList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getYbtOrderList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>